<div class="profile-container">
    <div class="profile-content">
        <div class="personal-details">

            <div class="header-block">
                <div class="header-title">
                    <app-breadcrumb></app-breadcrumb>
                </div>
                <div class="add-block">

                    <button title="Add" data-toggle="modal" data-target="#addImageModal"><i class="bi bi-plus-lg"></i>
                        {{ 'generic.add' |
                        translate }}</button>

                </div>
            </div>

            <table class="table table-striped">
                <thead>
                    <tr>
                        <th style="width: 60%;">Name</th>
                        <th style="width: 30%;">Created At</th>
                        <th style="width: 10%;text-align: center;padding: 0;" class="">{{ 'generic.action' | translate
                            }}</th>
                    </tr>
                </thead>
            </table>
            <div *ngIf="!isLoading">
                <div class="data-view" *ngFor="let list of allFacesPersons | paginate : {
                    itemsPerPage: tableSize,
                    currentPage: pageNumber,
                    totalItems: totalRecords
                    }  ;let i = index">

                    <p style="width: 60%;">{{list.name || " -- " }}</p>
                    <p style="width: 30%;">{{(list.created_at | date: 'dd/MM/yyyy HH:mm:ss') || " -- " }}</p>

                    <p class="action-buttons" style="width: 10%;padding-left: 25px;">
                        <i data-toggle="modal" title="View" (click)="getFacesImages(list)" data-target="#viewModal"
                            class="bi bi-eye-fill"></i>
                        <i title="Edit" class="bi bi-pencil-square" (click)="getFacesImages(list)" data-toggle="modal"
                            data-target="#editModal" style="margin-left: 8px;"></i>
                        <i title="Delete" class="bi bi-trash3" (click)="setDeletePerson(list)" data-toggle="modal"
                            data-target="#deleteModal" style="margin-left: 8px;"></i>
                    </p>
                </div>
            </div>



            <div class="loader" *ngIf="isLoading">
                <div class="spinner"></div>
            </div>

            <div class="paginator">
                <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize"
                    [totalRecords]="count" [showFirstLastIcon]="true" [showCurrentPageReport]="true"
                    [showPageLinks]="true" [showJumpToPageDropdown]="false"
                    currentPageReportTemplate="{first} - {last} of {totalRecords}">
                </p-paginator>
            </div>
            <div class="loader" *ngIf="!isLoading && allFacesPersons.length == 0">
                <div class="no-data">
                    <img src="assets/no-data-6.png" alt="">
                    <p>no data found</p>
                </div>

            </div>



        </div>
    </div>
</div>


<div class="modal fade" id="addImageModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content custom-modal">
            <!-- <div class="modal-header header-modern">
                <h5 class="modal-title title-modern" id="exampleModalLabel">
                    <i class="bi bi-images mr-2"></i> Add Images
                </h5>
                <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" (click)="closePopUp()" style="color: white !important; opacity: 1;">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div> -->

            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Add Images
                    <span data-dismiss="modal">
                        <i class="bi bi-x-lg" (click)="closePopUp()"></i>
                    </span>
                </h5>
            </div>

            <div class="modal-body body-modern" style="padding: 30px !important; overflow: visible;">
                <div class="row mb-4 mt-2">
                    <div class="col-12">
                        <div class="form-group mb-0">
                            <label class="label-modern"
                                style="line-height: 1.5; display: block; padding-top: 5px; margin-bottom: 10px;">Image
                                Name <span class="text-danger">*</span></label>
                            <input [(ngModel)]="name" type="text" class="form-control input-modern"
                                placeholder="Enter image name...">
                        </div>
                    </div>
                </div>

                <div class="row mb-4 pb-3 border-bottom">
                    <div class="col-12">
                        <div class="form-group mb-0">
                            <label class="label-modern"
                                style="line-height: 1.5; display: block; padding-top: 5px; margin-bottom: 10px;">Upload
                                Image <span class="text-danger">*</span></label>
                            <div class="upload-container">
                                <input type="file" id="imageUpload" accept="image/*" (change)="browseImage($event)"
                                    style="display: none;">
                                <label for="imageUpload" class="upload-dropzone mt-2"
                                    style="padding: 40px 20px; display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center;">
                                    <i class="bi bi-cloud-arrow-up mb-3" style="font-size: 3rem; color: #818cf8;"></i>
                                    <div class="line-height-sm">
                                        <span class="upload-text-compact d-block mb-1"
                                            style="font-size: 1.1rem; font-weight: 600; color: #334155;">Click here to
                                            browse </span>
                                        <span class="upload-subtext-compact d-block"
                                            style="font-size: 0.85rem; color: #64748b;"> Supports JPG, PNG</span>
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <div class="preview-header">
                            <label class="label-modern m-0">Preview</label>
                            <span class="badge badge-pill badge-modern" *ngIf="imageUrls.length">{{imageUrls.length}}
                                image(s)</span>
                        </div>

                        <div class="preview-box mt-2">
                            <div *ngIf="imageUrls.length === 0" class="empty-preview py-5">
                                <i class="bi bi-image empty-icon"></i>
                                <p>No images selected</p>
                            </div>

                            <div class="gallery-grid" *ngIf="imageUrls.length > 0">
                                <div class="gallery-item" *ngFor="let url of imageUrls; let i = index">
                                    <img [src]="url" class="gallery-img" alt="Preview">
                                    <div class="remove-overlay" (click)="!isActionLoading && removeImage(i)" title="Remove Image" [style.pointer-events]="isActionLoading ? 'none' : 'auto'">
                                        <i class="bi bi-trash" *ngIf="!isActionLoading"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <button type="button" id="closeModalButton2" (click)="closePopUp()" class="btn btn-secondary"
                    data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>

                <button type="button" (click)="uploadImage()"
                    [disabled]="!name || imageUrls.length === 0 || isActionLoading" class="btn btn-primary">
                    <i class="bi bi-arrow-repeat spin-icon" *ngIf="isActionLoading"></i>
                    {{ 'generic.add' | translate }}
                </button>
            </div>
            <!-- <div class="modal-footer footer-modern">
                <button type="button" id="closeModalButton2" (click)="closePopUp()" class="btn btn-cancel"
                    data-dismiss="modal">
                    {{ 'generic.cancel' | translate }}
                </button>
                <button type="button" (click)="uploadImage()" class="btn btn-upload"
                    [disabled]="!name || imageUrls.length === 0">
                    <i class="bi bi-cloud-upload mr-2"></i> {{ 'generic.add' | translate }}
                </button>
            </div> -->
        </div>
    </div>
</div>

<!-- View Modal -->
<div class="modal fade" id="viewModal" tabindex="-1" aria-labelledby="viewModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content custom-modal">
            <div class="modal-header">
                <h5 class="modal-title" id="viewModalLabel">View Images: {{selectedPersonName}}
                    <span data-dismiss="modal" style="cursor: pointer;">
                        <i class="bi bi-x-lg"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body" style="padding: 30px !important;">
                <div class="loader" *ngIf="isViewLoading"
                    style="display: flex; justify-content: center; padding: 20px;">
                    <div class="spinner"></div>
                </div>
                <div *ngIf="!isViewLoading && selectedPersonImages.length === 0" class="empty-preview py-5 text-center">
                    <i class="bi bi-image empty-icon" style="font-size: 2rem; color: #cbd5e1;"></i>
                    <p style="color: #64748b; margin-top: 10px;">No images found</p>
                </div>
                <div class="gallery-grid" *ngIf="!isViewLoading && selectedPersonImages.length > 0">
                    <div class="gallery-item" *ngFor="let img of selectedPersonImages">
                        <img [src]="imageBaseUrl + img.url" class="gallery-img" alt="Person Image"
                            style="object-fit: cover; width: 100%; height: 100%;">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Edit Modal -->
<div class="modal fade" id="editModal" tabindex="-1" aria-labelledby="editModalLabel" aria-hidden="true"
    data-backdrop="static">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content custom-modal">
            <div class="modal-header">
                <h5 class="modal-title" id="editModalLabel">Edit Profile: {{selectedPersonName}}
                    <span data-dismiss="modal" style="cursor: pointer;">
                        <i class="bi bi-x-lg" (click)="closePopUp()"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body" style="padding: 30px !important; overflow: visible;">
                <h6 class="mb-3" style="color: #334155; font-weight: 600;">Existing Images</h6>
                <div class="loader" *ngIf="isViewLoading"
                    style="display: flex; justify-content: center; padding: 20px;">
                    <div class="spinner"></div>
                </div>
                <div *ngIf="!isViewLoading && selectedPersonImages.length === 0"
                    class="empty-preview py-3 text-center mb-4">
                    <p style="color: #64748b;">No images found</p>
                </div>
                <div class="gallery-grid mb-4" *ngIf="!isViewLoading && selectedPersonImages.length > 0">
                    <div class="gallery-item" *ngFor="let img of selectedPersonImages">
                        <img [src]="imageBaseUrl + img.url" class="gallery-img" alt="Person Image"
                            style="object-fit: cover; width: 100%; height: 100%;">
                        <div class="remove-overlay" (click)="!isActionLoading && prepareDeleteImage(img.filename)"
                            data-toggle="modal" data-target="#deleteImageModal"
                            [style.opacity]="isActionLoading ? '0.5' : ''" 
                            [style.pointer-events]="isActionLoading ? 'none' : 'auto'"
                            title="Delete Server Image">
                            <i class="bi bi-trash" *ngIf="!isActionLoading"></i>
                            <i class="bi bi-arrow-repeat spin-icon"
                                *ngIf="isActionLoading && selectedDeletingImage === img.filename"></i>
                        </div>
                    </div>
                </div>

                <hr>

                <h6 class="mb-3 mt-4" style="color: #334155; font-weight: 600;">Add New Images</h6>
                <div class="row mb-4 pb-3 border-bottom">
                    <div class="col-12">
                        <div class="form-group mb-0">
                            <div class="upload-container">
                                <input type="file" id="editImageUpload" accept="image/*" (change)="browseImage($event)"
                                    style="display: none;">
                                <label for="editImageUpload" class="upload-dropzone mt-2"
                                    style="padding: 30px 20px; display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center; border: 2px dashed #cbd5e1; border-radius: 8px; cursor: pointer;">
                                    <i class="bi bi-cloud-arrow-up mb-2" style="font-size: 2.5rem; color: #818cf8;"></i>
                                    <div class="line-height-sm">
                                        <span class="upload-text-compact d-block mb-1"
                                            style="font-size: 1rem; font-weight: 600; color: #334155;">Click here to
                                            browse new images</span>
                                        <span class="upload-subtext-compact d-block"
                                            style="font-size: 0.85rem; color: #64748b;">Supports JPG, PNG</span>
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <div class="preview-header">
                            <label class="label-modern m-0">New Image Previews</label>
                            <span class="badge badge-pill badge-modern" *ngIf="imageUrls.length">{{imageUrls.length}}
                                image(s)</span>
                        </div>
                        <div class="preview-box mt-2">
                            <div *ngIf="imageUrls.length === 0" class="empty-preview py-4 text-center">
                                <i class="bi bi-image empty-icon" style="font-size: 1.5rem; color: #cbd5e1;"></i>
                                <p style="color: #64748b; margin-top: 5px;">No new images selected</p>
                            </div>
                            <div class="gallery-grid" *ngIf="imageUrls.length > 0">
                                <div class="gallery-item" *ngFor="let url of imageUrls; let i = index">
                                    <img [src]="url" class="gallery-img" alt="Preview">
                                    <div class="remove-overlay" (click)="!isActionLoading && removeImage(i)" title="Remove Image" [style.pointer-events]="isActionLoading ? 'none' : 'auto'">
                                        <i class="bi bi-trash" *ngIf="!isActionLoading"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" (click)="closePopUp()" class="btn btn-secondary"
                    data-dismiss="modal">Close</button>
                <button type="button" (click)="updatePersonImages()"
                    [disabled]="imageUrls.length === 0 || isActionLoading" class="btn btn-primary">
                    <i class="bi bi-arrow-repeat spin-icon" *ngIf="isActionLoading"></i>
                    Upload New Images
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Delete Modal -->
<div class="modal fade" id="deleteModal" tabindex="-1" aria-labelledby="deleteModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content custom-modal">
            <div class="modal-header">
                <h5 class="modal-title" id="deleteModalLabel">Delete Profile
                    <span data-dismiss="modal" style="cursor: pointer;">
                        <i class="bi bi-x-lg"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body text-center" style="padding: 40px 20px;">
                <p style="font-size: 1.1rem; color: #334155;">Are you sure you want to delete profile
                    <strong>{{selectedPersonName}}</strong>?</p>
            </div>
            <div class="modal-footer justify-content-center">
                <button type="button" id="closeDeleteModalButton" class="btn btn-secondary"
                    data-dismiss="modal">Cancel</button>
                <button type="button" (click)="deletePersonProfile()" [disabled]="isActionLoading"
                    class="btn btn-danger">
                    <i class="bi bi-arrow-repeat spin-icon" *ngIf="isActionLoading"></i>
                    Delete Profile
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Delete Image Modal -->
<div class="modal fade" id="deleteImageModal" tabindex="-1" aria-labelledby="deleteImageModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content custom-modal">
            <div class="modal-header">
                <h5 class="modal-title" id="deleteImageModalLabel">Delete Image
                    <span data-dismiss="modal" style="cursor: pointer;">
                        <i class="bi bi-x-lg"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body text-center" style="padding: 40px 20px;">
                <p style="font-size: 1.1rem; color: #334155;">Are you sure you want to delete this image?</p>
            </div>
            <div class="modal-footer justify-content-center">
                <button type="button" id="closeDeleteImageModalButton" class="btn btn-secondary"
                    data-dismiss="modal">Cancel</button>
                <button type="button" (click)="deleteSingleImage()" [disabled]="isActionLoading"
                    class="btn btn-danger">
                    <i class="bi bi-arrow-repeat spin-icon" *ngIf="isActionLoading"></i>
                    Delete Image
                </button>
            </div>
        </div>
    </div>
</div>